<template>
  <div class="center">
    <div class="waitingcom_title">
      <el-form
        label-width="80px"
        :model="formLabelAlign"
        ref="formLabelAlign"
        :label-position="labelPosition"
      >
        <el-form-item label="目录名称：" prop="dayNum">
          <el-input
            v-model.trim="formLabelAlign.dayNum"
            placeholder="请输入目录名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="添加时间：" prop="examBeginDate">
          <div class="block">
            <el-date-picker
              @change="searchChang"
              v-model.trim="examTime"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开通时间"
              end-placeholder="到期时间"
              :default-time="['00:00:00', '23:59:59']"
            >
            </el-date-picker>
          </div>
        </el-form-item>
      </el-form>
      <div class="query_btn">
        <el-button
          type="primary"
          icon="el-icon-search"
          class="searchbtn"
          @click="searchData"
          >搜索</el-button
        >
        <el-button
          icon="el-icon-refresh"
          class="searchbtn sonbtn"
          @click="resetForm('formLabelAlign')"
          >重置</el-button
        >

        <el-upload
                class="upload-demo"
                ref="upload"
                action=""
                multiple
                :limit="1"
                :show-file-list="false"
                :on-change="uploadPreview"
                :auto-upload="false"
              >
              <!-- <el-button style="width:auto;"  type="primary" class="upoload">题库包导入</el-button> -->
          </el-upload>
        
        
      </div>
    </div>
    <!-- 按钮部分 -->
    <div class="opera_btn">
      <el-button
       v-if="$root.$hasbtn('添加系列目录')"
        @click="
          dialogVisible = true;
          addBurieds();
        "
      >
        <i class="iconfont icon-action-add-hover"></i>添加系列目录
      </el-button>
      <el-button @click="encryption" v-if="$root.$hasbtn('试题保护')">
        <i class="iconfont icon-jiami"></i>试题保护{{
          isHavePwd == 0 ? "(已关闭)" : "(已开启)"
        }}
      </el-button>
      <el-button @click="deleteRowArr" v-if="$root.$hasbtn('批量删除')">
        <i class="iconfont icon-batch-shanchu"></i>批量删除
      </el-button>
    </div>
    <!-- 表单内容 -->
    <div class="hos_mian" v-loading="loading" v-if="customIs == 0">
      <el-table
        ref="tabledata"
        :data="getData"
        style="width: 100%"
        :row-class-name="tableRowClassName"
        @selection-change="handleSelectionChange"
        @row-click="StepsListRowClick"
        :row-key="getRowKeyOfTarget"
        :header-cell-style="{
          'background-color': '#8FCBFF',
          color: '#333333',
          height: '60px',
        }"
      >
        <el-table-column
          type="selection"
          width="80"
          :reserve-selection="true"
        ></el-table-column>
        <el-table-column label="序号" width="50">
          <template slot-scope="scope">
            {{ scope.$index + 1 + pageIndex * eachPageNum }}
          </template>
        </el-table-column>
        <el-table-column
          v-for="(item, index) in formColumns"
          :key="index"
          :prop="item.prop"
          :label="item.label"
          :width="item.width"
          height="150"
          label-height="50"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="address" label="操作" align="center" width="360">
          <template slot-scope="scope">
            <div class="operation_box">
              <el-button
                type="text"
                size="small"
                v-if="$root.$hasbtn('目录管理')"
                @click.stop="listmanage(scope.row)"
                >目录管理</el-button
              >
              <el-button
                type="text"
                size="small"
                v-if="$root.$hasbtn('编辑名称')"
                @click.stop="detailsBtn(scope.row)"
                >编辑名称</el-button
              >
              <el-button
                type="text"
                size="small"
                v-if="$root.$hasbtn('删除')"
                @click.stop="deleteRow(scope.row)"
                >删除</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>

      <div class="foot_box">
        <div class="foot_pagetions">
          <p>
            共有{{ total }}条记录，当前第{{ pageIndex + 1 }}/{{ pagesun }}页
          </p>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="showpageindex"
            :page-size="eachPageNum"
            :page-sizes="pagesizesarr"
            layout="prev, pager, next,sizes, jumper"
            :total="total"
            class="pagination"
          >
          </el-pagination>
        </div>
      </div>
    </div>

    <!-- 加密后展示的 -->
    <div class="mian_view" v-else-if="customIs == 1">
      <p>
        超级管理员“{{
          protect.CryptoRealName
        }}”已经开启试题保护，点击上方试题保护按钮可进行解密
      </p>
    </div>
    <!-- 添加题库 -->
    <div class="everywhere">
      <el-dialog
        title="添加系统目录"
        :visible.sync="dialogVisible"
        width="30%"
        :close-on-click-modal="false"
      >
        <div class="add_bank">
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="100px"
            class="demo-ruleForm"
          >
            <el-form-item label="系列目录名称：" prop="chapterName">
              <el-input
                v-model.trim="ruleForm.chapterName"
                placeholder="请输入系列目录名称"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="determineAdd()"> 确 定 </el-button>
        </span>
      </el-dialog>
    </div>
    <Pup ref="popup" :determineRow="determineRow" />
  </div>
</template>

<script>
import systemclass from "@/api/systemclassification";
import loginvuex from "@/store/index";
import Pup from "./Pup.vue";
import {
  CustomClassList,
  CheckAppExists,
  ChapterThree,
  ChapterManager,
  checkIsCrypto,
  BySeekName,
  ImportOfficial
} from "@/api/quebankmana.js";
import { checkCryptoPwd } from "@/api/examination.js";
import local from "@/utils/local.js";
export default {
  data() {
    return {
      stateArr: [], //存储开始时间和结束时间。
      formLabelAlign: {
        dayNum: "",
        examBeginDate: "", //开通时间
        examEndDate: "", // 结束时间
      },
      getDataCondition: {
        dayNum: "",
      },
      labelPosition: "right",
      pageIndex: 0, // 起始页
      eachPageNum: 10, //每页展示
      total: 100,
      TestID: "", // 接口返回的ID
      getData: [], //列表数据源
      ruleForm: {
        chapterName: "",
      },
      examTime: "",
      protect: {}, //加密后接口返回的数据
      multipleSelection: [],
      multipleSelectionIds: [],
      multipleSelectionCount: 0,
      loading: true,
      determineRow: {},
      dialogVisible: false, // 添加题库弹窗
      pagesizesarr: [5, 10, 20, 50, 100],
      TestLib: [], // 第一层树结构返回的数据
      isHavePwd: "", //试卷加密的状态
      userName: "",
      customIs: "", // 页面进来是否加密展示
      deleteState: "",
      formColumns: [
        {
          prop: "AppClassName",
          label: "系列目录名称",
          // width: "90px",
        },
        {
          prop: "CreateTime1",
          label: "添加时间",
        },
        {
          prop: "UserName",
          label: "添加人(人)",
        },
      ],
      pagesun: "", //一共多少页
      showpageindex: 1, //显示的索引盒子
      rules: {
        chapterName: [
          { required: true, message: "请输入系列目录名称", trigger: "blur" },
        ],
      },
    };
  },
  components: {
    Pup,
  },
  props: ["cutcoms"],
  methods: {
    // chang搜索
    searchChang() {
      this.loading = true;
      if (this.examTime == null) {
        this.formLabelAlign.examBeginDate = "";
        this.formLabelAlign.examEndDate = "";
      }
      this.getDatalist();
    },
    // 搜索
    searchData() {
      this.Buriedpoint(
        {
          code: "QuestionBank:Custom:search",
          parent_code: "QuestionBank:Custom",
        },
        "statetime"
      );
      this.loading = true;
      this.formLabelAlign.pageIndex = 0;
      if (this.formLabelAlign.dayNum) {
        this.getDataCondition.dayNum = this.formLabelAlign.dayNum;
      } else {
        this.getDataCondition.dayNum = "";
      }
      this.getDatalist();
    },
    // 勾选当前行激活check
    StepsListRowClick(row, column, event) {
      this.$refs.tabledata.toggleRowSelection(row);
    },
    // 添加埋点
    addBurieds() {
      this.Buriedpoint(
        {
          code: "QuestionBank:Custom:add",
          parent_code: "QuestionBank:Custom",
        },
        "statetime"
      );
    },
    // 重置
    resetForm(formExamin) {
      this.Buriedpoint(
        {
          code: "QuestionBank:Custom:rest",
          parent_code: "QuestionBank:Custom",
        },
        "statetime"
      );
      this.$refs[formExamin].resetFields();
      // this.reqcurrentPage3 = 0;
      this.showpageindex = 1;
      this.pageIndex = 0;
      this.examTime = "";
      this.loading = true;
      this.getDataCondition.dayNum = "";
      this.formLabelAlign.examBeginDate = "";
      this.formLabelAlign.examEndDate = "";
      this.getDatalist();
    },
    // 给每一行设置key
    getRowKeyOfTarget(row) {
      return row.AppClassID;
    },
    // 表格背景颜色
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "success-row";
      } else if (rowIndex % 2 === 0) {
        return "warning-row";
      }
      return "";
    },
    // 删除
    deleteRow(row) {
      this.Buriedpoint(
        {
          code: "QuestionBank:Custom:delete",
          parent_code: "QuestionBank:Custom",
        },
        "statetime"
      );
      this.deleteState = 0;
      this.$parent.currentRow = row;
      this.determineRow = row;
      this.$refs.popup.dialogVisibleObj.deleteStabe = true;
    },
    // 批量删除
    deleteRowArr() {
      this.Buriedpoint(
        {
          code: "QuestionBank:Custom:batchDelete",
          parent_code: "QuestionBank:Custom",
        },
        "statetime"
      );
      if (this.multipleSelection.length > 0) {
        this.deleteState = 1;
        this.$refs.popup.dialogVisibleObj.deleteStabe = true;
      } else {
        this.deleteState = 2;
        this.$refs.popup.dialogVisibleObj.deleteStabe = true;
      }
    },
    // 编辑目录
    detailsBtn(row) {
      this.Buriedpoint(
        {
          code: "QuestionBank:Custom:editName",
          parent_code: "QuestionBank:Custom",
        },
        "statetime"
      );
      this.determineRow = row;
      this.$refs.popup.dialogVisibleObj.ModifyThe = true;
      this.$refs.popup.ModifyForm.ModifyName = row.AppClassName;
    },
    // 分页
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.loading = true;
      this.eachPageNum = val;
      this.getDatalist(); // 重新发起请求
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pageIndex = val - 1;
      this.loading = true;
      this.getDatalist(); // 重新发起请求
    },
    handleSelectionChange(val) {
      this.multipleSelectionIds = [];
      this.multipleSelection = val; // 批量删除多选状态
      this.multipleSelectionCount = 0;
      val.forEach((row) => {
        this.multipleSelectionIds.push(row.AppClassID);
      });
      this.multipleSelection = val;
      this.multipleSelectionCount = this.multipleSelection.length;
    },
    // 数据处理
    dealData() {
      this.getData.map((item) => {
        item.CreateTime1 = this.$moment(item.CreateTime).format(
          "YYYY/MM/DD HH:mm"
        );
        for (let ztiem in item) {
          if (item[ztiem] === "" || item[ztiem] === null) {
            item[ztiem] = "未设置";
          }
        }
      });
    },
    // 列表页
    async getDatalist() {
      if (this.examTime) {
        const time = JSON.parse(JSON.stringify(this.examTime));
        this.formLabelAlign.examBeginDate = this.$moment(time[0]).format(
          "YYYY-MM-DD HH:mm:ss"
        );
        this.formLabelAlign.examEndDate = this.$moment(time[1]).format(
          "YYYY-MM-DD HH:mm:ss"
        );
      }
      let res = {
        guid: JSON.parse(loginvuex.state.userlist).guid,
        UserID: JSON.parse(loginvuex.state.userlist).userID,
        userID: JSON.parse(loginvuex.state.userlist).userID,
        url: "/api/customTest/ChapterManager/CustomClassList",
        hid: JSON.parse(loginvuex.state.hid),
        pageIndex: this.pageIndex,
        PageShow: this.eachPageNum,
        Directory: this.getDataCondition.dayNum,
        createStartTime: this.formLabelAlign.examBeginDate,
        createEndTime: this.formLabelAlign.examEndDate,
        keyStr: ".bottom",
      };
      this.pageIndex = 0;
      const Data = await CustomClassList(res);
      if (Data.data.Status === 200) {
        this.getData = Data.data.Data.Data;
        this.total = Data.data.Data.count;
        this.pagesun = Data.data.Data.pageCount;
        setTimeout(() => {
          this.loading = false;
        }, 500);
        this.dealData();
      }
      console.log(Data.data.Data.Data, "列表数据");
    },
    // 添加题库
    async ChapterManager() {
      let res = {
        _examID: "", //课件ID
        guid: JSON.parse(loginvuex.state.userlist).guid,
        UserID: JSON.parse(loginvuex.state.userlist).userID,
        userID: JSON.parse(loginvuex.state.userlist).userID,
        hid: JSON.parse(loginvuex.state.hid),
        Level: 0, //等级
        ChapterName: this.ruleForm.chapterName, //试题名称
        ParentID: -1,
        AppID: -1,
      };
      const Data = await ChapterManager(res);
      if (Data.status === 200) {
        this.TestID = Data.data.Data.ID;
        this.$parent.isselectitems["AppClassID"] = Data.data.Data.ID;
        console.log(this.$parent.isselectitems.AppClassID);
        this.$parent.TestID = Data.data.Data.ID;
      }
      console.log(Data.data.Data.ID, "data123");
    },
    // 第一层数据
    async hapterThree() {
      let res = {
        ClassID: this.TestID,
        guid: JSON.parse(loginvuex.state.userlist).guid,
        userID: JSON.parse(loginvuex.state.userlist).userID,
        hid: JSON.parse(loginvuex.state.hid),
      };
      const Data = await ChapterThree(res);
      if (Data.status === 200) {
        this.TestLib = Data.data.Data.TestLib;
      }
      console.log(Data.data.Data.TestLib, "第一层数据结构");
    },
    // 设置加密后接口
    async protectList() {
      let res = {
        guid: JSON.parse(loginvuex.state.userlist).guid,
        userID: JSON.parse(loginvuex.state.userlist).userID,
        hid: JSON.parse(loginvuex.state.hid),
      };
      const Data = await checkIsCrypto(res);
      if (Data.status === 200) {
        this.protect = Data.data.Data;
        this.customIs = Data.data.Data.CustomIsCrypto;
        if (Data.data.Data.CustomIsCrypto == 0) {
          this.customIs = 0;
          this.$refs.popup.passwordForm.userPaw = "";
          this.getDatalist();
        } else {
          this.customIs = 1;
          this.$refs.popup.passwordForm.userPaw = "";
          this.getDatalist();
        }
      }
      console.log(Data.data.Data);
    },
    // 试卷加密
    async encryption() {
      this.Buriedpoint(
        {
          code: "QuestionBank:Custom:testProtect",
          parent_code: "QuestionBank:Custom",
        },
        "statetime"
      );
      let res = {
        guid: JSON.parse(loginvuex.state.userlist).guid,
        userID: JSON.parse(loginvuex.state.userlist).userID,
        hid: JSON.parse(loginvuex.state.hid),
      };
      const Data = await checkCryptoPwd(res);
      if (Data.status === 200) {
        this.isHavePwd = Data.data.Data.isHavePwd;
        if (this.isHavePwd === 0) {
          // 为0的时候表示没有设置密码去设置密码页面
          this.$router.push("/user_center/modifyThe");
        } else if (this.isHavePwd === 1) {
          // this.$router.push("/user_center/setEncy");
          this.$refs.popup.dialogVisibleObj.everywhere = true;
        }
      } else {
        this.$message.error("请求失败");
      }
    },
    // 进来验证按钮是否加密
    async encry() {
      let res = {
        guid: JSON.parse(loginvuex.state.userlist).guid,
        userID: JSON.parse(loginvuex.state.userlist).userID,
        hid: JSON.parse(loginvuex.state.hid),
      };
      const Data = await checkCryptoPwd(res);
      if (Data.status === 200) {
        this.isHavePwd = Data.data.Data.isHavePwd;
        if (this.isHavePwd === 1) {
          //  this.cutcoms(3);
          this.customIs = 1; // 如果加密了就去展示列表
        } else {
          this.customIs = 0;
        }
      }
    },
    Buriedpoint(itemt, isstate) {
      if (isstate == "statetime") {
        //次数
        let parmas = {
          type: "2",
          code: itemt.code,
          parent_code: itemt.parent_code,
          stay_start_time: this.$moment().format("YYYY-MM-DD HH:mm:ss"),
          stay_end_time: this.$moment().format("YYYY-MM-DD HH:mm:ss"),
          stay_time: 1,
          ation_source: null,
          source: "khy",
          ip: null,
          userID: JSON.parse(loginvuex.state.userlist).userID,
          guid: JSON.parse(loginvuex.state.userlist).guid,
        };
        systemclass.addburied(parmas);
      } else {
        //闭环时间
        if (this.stateArr.length == 0) {
          this.stateArr[0] = this.$moment().format("YYYY-MM-DD HH:mm:ss");
        } else {
          this.stateArr[1] = this.$moment().format("YYYY-MM-DD HH:mm:ss");
          let statetime = this.$moment(new Date(this.stateArr[1])).diff(
            new Date(this.stateArr[0]),
            "seconds"
          );
          let parmas = {
            type: "2",
            code: itemt.code,
            parent_code: itemt.parent_code,
            stay_start_time: this.stateArr[0],
            stay_end_time: this.stateArr[1],
            stay_time: statetime,
            ation_source: null,
            source: "khy",
            ip: null,
            userID: JSON.parse(loginvuex.state.userlist).userID,
            guid: JSON.parse(loginvuex.state.userlist).guid,
          };
          systemclass.addburied(parmas);
          this.stateArr = [];
        }
      }
    },
    // 确定添加
    async determineAdd() {
      let res = {
        AppName: this.ruleForm.chapterName,
        guid: JSON.parse(loginvuex.state.userlist).guid,
        UserID: JSON.parse(loginvuex.state.userlist).userID,
        userID: JSON.parse(loginvuex.state.userlist).userID,
        hid: JSON.parse(loginvuex.state.hid),
      };
      if (this.ruleForm.chapterName == "") {
        this.$refs.popup.fang = 0;
        this.$refs.popup.dialogVisibleObj.batchDelete = true;
      } else {
        const Data = await CheckAppExists(res);
        if (Data.status === 200) {
          if (Data.data.Data.Result == 1) {
            this.$refs.popup.fang = 1;
            this.$refs.popup.dialogVisibleObj.batchDelete = true;
          } else {
            this.$parent.textOne = this.ruleForm.chapterName;
            // this.ruleForm.chapterName = ''
            await this.ChapterManager(); // 拿到ID
            //  this.hapterThree(); // 拿到第一层数据  没用
            this.dialogVisible = false;
            this.cutcoms(1);
          }
        } else {
          this.$message.error("错了哦，这是一条错误消息");
        }
        console.log(Data.data.Data.Result, "嘻嘻嘻");
      }
    },
    //目录管理
    listmanage(items) {
      localStorage.setItem("isreload", true);
      this.Buriedpoint({
        code: "QuestionBank:Custom:dirManage",
        parent_code: "QuestionBank:Custom",
      });
      this.$parent.isselectitems = items;
      console.log(items);
      this.cutcoms(1);
    },
    //文件上传
    uploadPreview(file) {
      //文件上传，增加进度条，
      console.log(file, 0);
      this.filename = file.name;
      let filetype = file.name.split(".");
      filetype = filetype[filetype.length - 1]; //文件类型。
      if (
        filetype != "zip"&&filetype != "rar"
      ) {
        this.$message({
          message: "文件格式不合法",
          type: "warning",
        });
        this.filename = "";
        return;
      } else if (file.raw.size > 304857600) {
        this.$message({
          message: "文件大小不能超过100MB",
          type: "warning",
        });
        this.filename = "";
        return;
      }
      this.sendupload(file)
    },
     async sendupload(file) {
      // this.isState = true;
      let formData = new FormData();
      formData.append("userID", JSON.parse(loginvuex.state.userlist).userID);
      formData.append("guid", JSON.parse(loginvuex.state.userlist).guid);
      formData.append("name", file.name);
      formData.append("type", file.raw.type);
      formData.append("lastModifiedDate", new Date());
      formData.append("size", file.raw.size);
      formData.append("file", file.raw);
      let res = await ImportOfficial(formData);
      if (res.data.Status == 200) {
        this.$message({
          type: "success",
          message: res.data.Data,
        });
        
      } else{
        this.$message.error({
          message: res.data.Data,
          type: "warning",
        });
      }
    }
  },
  async created() {
    this.stateArr = [];
    await this.getDatalist();
    // await this.encry();
    await this.protectList();
    // await this.protectList();
    this.userName = JSON.parse(local.get("userlist"));
    localStorage.removeItem("isreload");
  },
  // beforeDestroy(){
  //   this.$parent.isloading = true
  // }
};
</script>

<style lang="scss" scoped>
.center {
  height: 100%;
  width: 100%;
  min-width: 1650px;
  background-color: rgb(255, 255, 255);
}
.waitingcom_title {
  height: 81px;
  padding: 24px 24px 16px 10px;
  border-bottom: 1px solid #f8f8f8;
  display: flex;
  ::v-deep .el-form-item__label {
    margin-left: 24px;
    width: 87px !important;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #333333;
  }
  ::v-deep .el-form-item__content {
    margin-left: 115px !important;
  }
}
.el-form {
  display: flex;
  ::v-deep .el-input > .el-input__inner {
    width: 200px;
  }
}
.query_btn {
  margin: 0;
  display: flex;
  .el-button {
    width: 88px;
    height: 40px;
    margin-left: 24px;
  }
}
.hos_mian {
  margin-top: 24px;
  padding: 0px 24px;
  min-height: 560px;
  ::v-deep .el-table th:nth-child(1) {
    opacity: 1;
    border-radius: 4px 0px 0px 4px;
  }
  ::v-deep .el-table th:nth-child(8) {
    opacity: 1;
    border-radius: 0px 4px 4px 0px;
  }
  ::v-deep .el-table th > .cell {
    align-items: center !important;
    text-align: center;
  }
}
// 分页
.foot_box {
  position: relative;
  height: 88px;
}
.foot_pagetions {
  display: flex;
  position: absolute;
  right: 16px;
  bottom: 30px;
  p {
    text-align: center;
    line-height: 32px;
    font-family: 微软雅黑;
    color: #949494;
  }
  span {
    line-height: 32px;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #333333;
    b {
      color: #ff0000;
    }
  }
}
.pagination {
  ::v-deep .el-pager {
    li {
      border: 1px solid #d9d9d9;
      margin-right: 8px;
      &.active {
        color: #ffffff;
        background-color: #409eff;
        border: none;
      }
    }
  }
}
::v-deep .el-table .warning-row {
  background: #fff !important;
}

::v-deep .el-table .success-row {
  background: #f8fcff !important;
}
.operation_box {
  .el-button {
    font-size: 16px;
    margin-left: 30px;
  }
}
.opera_btn {
  display: flex;
  margin: 14px 0px 20px 0px;
  width: 88px;
  height: 40px;
  opacity: 1;
  padding: 0px 24px !important;
  border-radius: 4px;
  ::v-deep .el-button {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    letter-spacing: 1px;
    margin-right: 24px;
    span > i {
      font-size: 14px !important;
      margin-right: 5px;
    }
  }
  .el-button:nth-child(1) {
    background: #1890ff;
    width: 140px;
  }
  .el-button:nth-child(2) {
    background: #ee6717;
    width: 160px;
  }
  .el-button:nth-child(3) {
    background: #e54d4d;
    width: 104px;
    span > i {
      font-size: 16px !important;
      margin-right: 5px;
    }
  }
}
::v-deep .cell {
  text-align: center;
}
// 弹窗样式
.everywhere {
  ::v-deep .el-dialog {
    width: 552px !important;
    height: 240px !important;
    border-radius: 5px 5px 0px 0px;
  }
  .el-dialog__wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  ::v-deep .el-dialog__body {
    padding: 24px;
  }
  ::v-deep .el-dialog__header {
    height: 55px;
    opacity: 1;
    border-radius: 5px 5px 0px 0px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #333333;
    background: linear-gradient(
      180deg,
      #64b5ff 0%,
      rgba(199, 228, 255, 1) 100%
    ) !important;
  }
  .dialog-footer {
    display: flex;
    justify-content: center;
    align-items: center;
    button:nth-child(1) {
      margin-right: 50px;
    }
  }
  p {
    text-align: center;
    font-size: 16px;
  }
  ::v-deep.el-form-item__label {
    width: 120px !important;
  }
  ::v-deep .el-form-item__content {
    margin-left: 120px !important;
  }
  ::v-deep.el-input__inner {
    width: 350px !important;
    height: 40px;
  }
}
.mian_view {
  min-height: 640px;
  border-radius: 0px 0px 10px 10px;
  display: flex;
  justify-content: center;
  p {
    font-size: 20px;
    color: #333333;
    margin-top: 50px;
    font-family: PingFang SC;
    font-weight: 400;
  }
}
</style>